import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { ToolsPanelToggleButton } from "./ToolsPanelToggleButton";

type FilterResetButtonProps = {
    isAnyFilterApplied: boolean;
    resetFilters: () => void;
};

export function FilterResetButton({
    isAnyFilterApplied,
    resetFilters,
}: FilterResetButtonProps) {
    return (
        <ToolsPanelToggleButton
            isActivated={isAnyFilterApplied}
            setIsActivated={resetFilters}
            tooltipTextWhenActivated="Reset filters"
            disabled={!isAnyFilterApplied}
        >
            <FilterAltIcon
                sx={{
                    height: '18px',
                    width: '18px',
                }}
            />
        </ToolsPanelToggleButton>
    );
}
